/* Hospital at Home — Arabic dictionary.
 * Comprehensive EN -> AR map for visible UI strings.
 * Add new entries as features evolve; missing keys fall back to English. */

export const AR = {
  // ── Brand / Shell ──────────────────────────────────────────
  "Hospital at Home": "المستشفى في المنزل",
  "Care Beyond Walls": "رعاية بلا حدود",
  "Hospital @ Home": "المستشفى في المنزل",
  "Admin Console": "لوحة المسؤول",
  "Care Beyond walls": "رعاية بلا حدود",
  "Workspace": "مساحة العمل",
  // R-014 — nav entries whose backendv2 module isn't built yet
  "Soon": "قريباً",
  "not yet migrated to the new backend": "لم يتم نقلها بعد إلى الواجهة الخلفية الجديدة",
  "Home": "الرئيسية",
  "Search patients, users, facilities…": "ابحث عن المرضى والمستخدمين والمنشآت…",
  "All Facilities": "جميع المنشآت",
  "Facility scope": "نطاق المنشأة",
  "Select": "اختر",
  "Sign out": "تسجيل الخروج",
  "Sign in": "تسجيل الدخول",
  "Signing in…": "جاري تسجيل الدخول…",
  "Welcome back": "مرحباً بعودتك",
  "Use your H@H administrator credentials to continue.": "استخدم بيانات مسؤول H@H للمتابعة.",
  "Work email": "البريد الإلكتروني للعمل",
  "Password": "كلمة المرور",
  "Demo accounts": "حسابات تجريبية",
  "Click a card to autofill credentials, then press": "اضغط على البطاقة لتعبئة البيانات تلقائياً ثم اضغط",
  "System Admin": "مسؤول النظام",
  "H@H Physician": "طبيب H@H",
  "Nurse (Hotline)": "ممرض (الخط الساخن)",
  "H@H Care Coordinator": "منسق الرعاية H@H",
  "Hospital Coordinator": "منسق المستشفى",
  "Home Care Team": "فريق الرعاية المنزلية",
  "System operational": "النظام يعمل",
  "Command Center": "مركز القيادة",
  "Run hospital-at-home care with clinical precision.": "أدر رعاية المستشفى في المنزل بدقة سريرية.",
  "Unified administration for patients, clinicians, facilities, and audit — the foundation for your entire H@H ecosystem.":
    "إدارة موحّدة للمرضى والأطباء والمنشآت وسجلات التدقيق — أساس منظومة H@H الكاملة.",
  "Patient Ops": "عمليات المرضى",
  "Roles & Audit": "الأدوار والتدقيق",
  "Facility Network": "شبكة المنشآت",
  "Hospital at Home Platform": "منصة المستشفى في المنزل",
  "Loading…": "جاري التحميل…",
  "User": "مستخدم",

  // ── Sidebar nav ────────────────────────────────────────────
  "Dashboard": "لوحة التحكم",
  "User Management": "إدارة المستخدمين",
  "Patient Management": "إدارة المرضى",
  "Facility Management": "إدارة المنشآت",
  "Roles & Permissions": "الأدوار والصلاحيات",
  "Lookups": "القوائم المرجعية",
  "Clinical Protocols": "البروتوكولات السريرية",
  "RPM Thresholds": "حدود المراقبة عن بُعد",
  "Reports & Exports": "التقارير والتصدير",
  "Audit Trail": "سجل التدقيق",

  "RPM Command Center": "مركز قيادة المراقبة عن بُعد",
  "Active Alerts": "التنبيهات النشطة",
  "Interventions": "التدخلات",

  "Fleet Command Center": "مركز قيادة الأسطول",
  "Fleet Dashboard": "لوحة الأسطول",
  "Live Operations Map": "خريطة العمليات الحية",
  "Visit Board": "لوحة الزيارات",
  "Clinicians": "الأطباء",
  "Vehicles": "المركبات",

  "Teleconsultation": "الاستشارة عن بُعد",
  "Consultations": "الاستشارات",

  "Clinical Operations": "العمليات السريرية",
  "Active Patients": "المرضى النشطون",
  "My Patients": "مرضاي",
  "High-Risk Patients": "المرضى ذوو الخطورة العالية",
  "RPM Escalations": "تصعيدات المراقبة",
  "Hotline Follow-Ups": "متابعات الخط الساخن",
  "Upcoming Teleconsultations": "الاستشارات القادمة",
  "Home Visits": "الزيارات المنزلية",
  "Clinical Tasks": "المهام السريرية",

  "Executive Dashboard": "اللوحة التنفيذية",
  "Operational Dashboard": "اللوحة التشغيلية",
  "Clinical Safety": "السلامة السريرية",
  "Population Health": "صحة السكان",
  "Active Interventions": "التدخلات النشطة",
  "SLA Manager": "إدارة SLA",
  "Patient Explorer": "مستكشف المرضى",
  "Reports": "التقارير",

  "Hospital Workspace": "مساحة عمل المستشفى",
  "Onboarding Dashboard": "لوحة استقبال المرضى",
  "Create Request": "إنشاء طلب",
  "My Requests": "طلباتي",
  "Drafts": "المسودات",
  "Information Requested": "معلومات مطلوبة",
  "Rejected": "مرفوض",
  "Completed": "مكتمل",

  "H@H Operations": "عمليات H@H",
  "Medical Review Queue": "قائمة المراجعة الطبية",
  "Assessment Queue": "قائمة التقييم",
  "Awaiting Assignment": "بانتظار التعيين",
  "Assigned Visits": "زيارات معيّنة",
  "Visit Findings": "نتائج الزيارة",

  "Field Workspace": "مساحة العمل الميدانية",
  "Visits Dashboard": "لوحة الزيارات",
  "In Progress": "قيد التنفيذ",
  "Completed Visits": "زيارات مكتملة",

  "Nurse Hotline": "الخط الساخن للممرضين",
  "Hotline Dashboard": "لوحة الخط الساخن",
  "New Hotline Session": "جلسة جديدة",
  "Active Sessions": "جلسات نشطة",
  "Decision Pending": "بانتظار القرار",
  "Escalated": "مصعَّد",
  "Follow-Up Required": "بحاجة متابعة",
  "Closed Sessions": "جلسات مغلقة",

  // ── Page headers / subtitles ───────────────────────────────
  "System Admin Command Center": "مركز قيادة مسؤول النظام",
  "What's happening across the Hospital @ Home network — right now.":
    "ما يحدث الآن عبر شبكة المستشفى في المنزل.",
  "Total Users": "إجمالي المستخدمين",
  "Active Patients ": "المرضى النشطون",
  "Facilities": "المنشآت",
  "Audit Events Today": "أحداث التدقيق اليوم",
  "Active Users": "المستخدمون النشطون",
  "Total Roles": "إجمالي الأدوار",
  "Lookup Categories": "فئات القوائم المرجعية",
  "Total Patients": "إجمالي المرضى",
  "Trends": "الاتجاهات",
  "Audit events — last 7 days": "أحداث التدقيق — آخر 7 أيام",
  "Workforce": "القوى العاملة",
  "User distribution by role": "توزيع المستخدمين حسب الدور",
  "Live": "مباشر",
  "Last 24 hours": "آخر 24 ساعة",
  "active": "نشط",
  "of": "من",
  "total": "إجمالي",
  "operational": "تعمل",

  "Immutable record of every action across the Hospital @ Home platform.":
    "سجل غير قابل للتعديل لكل إجراء على منصة المستشفى في المنزل.",
  "Hospital @ Home Command Center": "مركز قيادة المستشفى في المنزل",
  "Real-time operational and clinical intelligence":
    "ذكاء تشغيلي وسريري في الوقت الفعلي",

  // ── Common buttons / labels ────────────────────────────────
  "Save": "حفظ",
  "Cancel": "إلغاء",
  "Delete": "حذف",
  "Edit": "تعديل",
  "Create": "إنشاء",
  "Add": "إضافة",
  "Remove": "إزالة",
  "Update": "تحديث",
  "Submit": "إرسال",
  "Close": "إغلاق",
  "Confirm": "تأكيد",
  "Back": "رجوع",
  "Next": "التالي",
  "Previous": "السابق",
  "Search": "بحث",
  "Filter": "تصفية",
  "Clear": "مسح",
  "Reset": "إعادة تعيين",
  "Apply": "تطبيق",
  "View": "عرض",
  "View All": "عرض الكل",
  "Refresh": "تحديث",
  "Export": "تصدير",
  "Download": "تنزيل",
  "Upload": "رفع",
  "Loading": "جاري التحميل",
  "No data": "لا توجد بيانات",
  "No results": "لا توجد نتائج",
  "Yes": "نعم",
  "No": "لا",
  "Active": "نشط",
  "Inactive": "غير نشط",
  "Status": "الحالة",
  "Type": "النوع",
  "Name": "الاسم",
  "Email": "البريد الإلكتروني",
  "Phone": "الهاتف",
  "Role": "الدور",
  "Created": "تم الإنشاء",
  "Updated": "تم التحديث",
  "Actions": "الإجراءات",
  "Details": "التفاصيل",
  "Overview": "نظرة عامة",
  "Settings": "الإعدادات",
  "Profile": "الملف الشخصي",
  "Notifications": "الإشعارات",
  "Help": "مساعدة",
  "Logout": "تسجيل الخروج",
  "Sign in to continue": "سجّل الدخول للمتابعة",
  "Required": "مطلوب",
  "Optional": "اختياري",
  "Save changes": "حفظ التغييرات",
  "Discard": "تجاهل",
  "All": "الكل",
  "None": "لا شيء",
  "Today": "اليوم",
  "Yesterday": "أمس",
  "This Week": "هذا الأسبوع",
  "This Month": "هذا الشهر",
  "Last 7 days": "آخر 7 أيام",
  "Last 30 days": "آخر 30 يوم",

  // ── Status / Clinical ──────────────────────────────────────
  "Draft": "مسودة",
  "Submitted": "تم الإرسال",
  "Pending": "قيد الانتظار",
  "Approved": "مُعتمد",
  "Under Review": "قيد المراجعة",
  "Critical": "حرج",
  "High Risk": "عالي الخطورة",
  "Stable": "مستقر",
  "Improving": "في تحسّن",
  "Deteriorating": "في تدهور",
  "Patient": "المريض",
  "Patients": "المرضى",
  "Diagnosis": "التشخيص",
  "Medications": "الأدوية",
  "Vitals": "العلامات الحيوية",
  "Notes": "الملاحظات",
  "Orders": "الأوامر الطبية",
  "MAR": "سجل إعطاء الأدوية",
  "Progress Notes": "ملاحظات التقدم",
  "Care Plan": "خطة الرعاية",
  "Admission": "القبول",
  "Discharge": "الخروج",
  "Visit": "زيارة",
  "Visits": "زيارات",
  "Appointment": "موعد",
  "Appointments": "المواعيد",
  "Schedule": "الجدول",
  "Today's Schedule": "جدول اليوم",
  "Severity": "الشدّة",
  "Priority": "الأولوية",
  "High": "عالي",
  "Medium": "متوسط",
  "Low": "منخفض",

  // ── Auth / Errors ──────────────────────────────────────────
  "Invalid credentials": "بيانات اعتماد غير صحيحة",
  "Login failed": "فشل تسجيل الدخول",
  "Session expired": "انتهت الجلسة",
  "Access denied": "تم رفض الوصول",
  "Something went wrong": "حدث خطأ ما",
  "Try again": "حاول مرة أخرى",
  "Saved": "تم الحفظ",
  "Created successfully": "تم الإنشاء بنجاح",
  "Updated successfully": "تم التحديث بنجاح",
  "Deleted successfully": "تم الحذف بنجاح",

  // ── Header / Misc ──────────────────────────────────────────
  "Switch to dark mode": "التبديل للوضع الداكن",
  "Switch to light mode": "التبديل للوضع الفاتح",
  "Language": "اللغة",
  "Theme": "المظهر",
  "Light": "فاتح",
  "Dark": "داكن",
  "English": "الإنجليزية",
  "Arabic": "العربية",
  "العربية": "العربية",

  // ── Page titles ────────────────────────────────────────────
  "Clinical Command Center": "مركز القيادة السريرية",
  "Nurse Hotline Command Center": "مركز قيادة الخط الساخن",
  "Onboarding Command Center": "مركز قيادة استقبال المرضى",
  "Onboarding Requests": "طلبات الاستقبال",
  "Population Health Dashboard": "لوحة صحة السكان",
  "RPM Active Alerts": "تنبيهات المراقبة النشطة",
  "RPM SLA": "SLA المراقبة",
  "RPM Interventions": "تدخلات المراقبة",
  "RPM Vital Thresholds": "حدود العلامات الحيوية",
  "Hotline SLA": "SLA الخط الساخن",
  "Onboarding SLA": "SLA الاستقبال",
  "Teleconsult SLA": "SLA الاستشارة",
  "Hotline Sessions": "جلسات الخط الساخن",
  "Lookups Management": "إدارة القوائم المرجعية",
  "Vehicle Management": "إدارة المركبات",
  "Visit Scheduling Board": "لوحة جدولة الزيارات",
  "Active Sessions Queue": "قائمة الجلسات النشطة",
  "Escalation Queue": "قائمة التصعيد",
  "Follow-Up Queue": "قائمة المتابعة",
  "Clinician Availability": "توفر الأطباء",
  "Command Center Reports": "تقارير مركز القيادة",
  "Configuration": "الإعداد",
  "Performance": "الأداء",
  "Protocol Execution": "تنفيذ البروتوكول",
  "Protocol metadata": "بيانات البروتوكول",
  "Service Configuration": "إعداد الخدمة",
  "Patient Identification": "تعريف المريض",
  "Patient Information": "معلومات المريض",
  "General Information": "معلومات عامة",
  "Clinical Information": "المعلومات السريرية",
  "Service Information": "معلومات الخدمة",
  "Referral Information": "معلومات الإحالة",
  "Audit Information": "معلومات التدقيق",
  "Value details": "تفاصيل القيمة",
  "Verification": "التحقق",
  "Assignment": "التعيين",
  "Assessment": "التقييم",
  "Chief Complaint": "الشكوى الرئيسية",
  "Add intervention": "إضافة تدخل",
  "Acknowledge alerts": "إقرار التنبيهات",
  "Notes & evidence": "الملاحظات والأدلة",
  "Session attachments": "مرفقات الجلسة",
  "Fleet": "الأسطول",

  // ── Subtitles ──────────────────────────────────────────────
  "All clinical actions recorded against monitored patients.": "جميع الإجراءات السريرية المسجلة على المرضى تحت المراقبة.",
  "Census, care team assignment, and patient lifecycle across the network.": "الإحصاء وتعيين فريق الرعاية ودورة حياة المريض عبر الشبكة.",
  "Cohort analysis and population insights": "تحليل الأفواج ورؤى السكان",
  "Configurable decision trees that nurses follow during hotline triage.": "أشجار قرار قابلة للتهيئة يتبعها الممرضون أثناء فرز الخط الساخن.",
  "Configure role-based access and clone permission templates.": "هيّئ الوصول حسب الأدوار وانسخ قوالب الصلاحيات.",
  "Download operational reports in CSV, Excel (.xlsx) or PDF formats.": "حمّل التقارير التشغيلية بصيغ CSV أو Excel أو PDF.",
  "Fleet vehicle registry — admin-managed.": "سجل مركبات الأسطول — تُدار من قبل المسؤول.",
  "H@H hubs, service configurations, and coverage areas.": "مراكز H@H وإعدادات الخدمات ومناطق التغطية.",
  "Live across RPM, Hotline, Teleconsult, Home Visits, Orders": "مباشر عبر المراقبة والخط الساخن والاستشارة والزيارات المنزلية والأوامر",
  "Live readiness, workload and capacity for all field clinicians.": "الجاهزية وعبء العمل والسعة المباشرة لجميع الأطباء الميدانيين.",
  "Manage clinicians, administrators, and staff across the H@H network.": "إدارة الأطباء والمسؤولين والموظفين عبر شبكة H@H.",
  "Real-time clinical overview and patient safety monitoring": "نظرة سريرية فورية ومراقبة سلامة المرضى",
  "Real-time monitoring of active H@H patients · auto-refresh every 30s": "مراقبة آنية لمرضى H@H النشطين · تحديث تلقائي كل 30 ثانية",
  "Real-time operational view of clinicians, visits, and vehicles.": "عرض تشغيلي آني للأطباء والزيارات والمركبات.",
  "Reference data, picklists, and configurable enumerations across the platform.": "البيانات المرجعية والقوائم المنسدلة عبر المنصة.",
  "Scheduled tasks": "المهام المجدولة",
  "Snapshot exports of every dashboard": "صور تصدير لكل لوحة",
  "Threshold breaches, NEWS2, AI deterioration, missing-reading and device alerts.": "تجاوزات الحدود وNEWS2 وتدهور الذكاء الاصطناعي والقراءات المفقودة وتنبيهات الأجهزة.",
  "Triage / dispatch": "الفرز / الإرسال",
  "Unified view across RPM, Hotline, Teleconsultations and Home Visits.": "عرض موحّد عبر المراقبة والخط الساخن والاستشارات والزيارات.",
  "Virtual care sessions across the H@H ecosystem.": "جلسات الرعاية الافتراضية عبر منظومة H@H.",
  "Visits sourced from Onboarding, RPM, Hotline and manual requests.": "زيارات مصدرها الاستقبال والمراقبة والخط الساخن والطلبات اليدوية.",
  "What needs attention": "ما يحتاج إلى اهتمام",
  "Workflow funnels, bottlenecks and SLA visibility": "قنوات العمل والاختناقات ووضوح SLA",
  "Workflow performance across modules": "أداء سير العمل عبر الوحدات",

  // ── Forms / labels ─────────────────────────────────────────
  "First name": "الاسم الأول",
  "Last name": "اسم العائلة",
  "Mobile number": "رقم الجوال",
  "Mobile": "الجوال",
  "Initial password": "كلمة المرور الأولية",
  "Last login": "آخر تسجيل دخول",
  "DOB": "تاريخ الميلاد",
  "Date of birth": "تاريخ الميلاد",
  "Gender": "الجنس",
  "Nationality": "الجنسية",
  "National ID": "الهوية الوطنية",
  "National ID / Iqama": "الهوية الوطنية / الإقامة",
  "MRN": "رقم الملف الطبي",
  "Address": "العنوان",
  "City": "المدينة",
  "State": "المنطقة",
  "Code": "الرمز",
  "Description": "الوصف",
  "Label": "التسمية",
  "Category": "الفئة",
  "Sort order": "ترتيب العرض",
  "Department": "القسم",
  "Source": "المصدر",
  "Scope": "النطاق",
  "Reason": "السبب",
  "Comments": "تعليقات",
  "Outcome": "النتيجة",
  "Plan": "الخطة",
  "Recommendations": "التوصيات",
  "Recommendation note (optional)": "ملاحظة التوصية (اختيارية)",
  "Symptoms": "الأعراض",
  "Symptom duration": "مدة الأعراض",
  "Frequency": "التكرار",
  "Dose": "الجرعة",
  "Dose Given": "الجرعة المُعطاة",
  "Route": "المسار",
  "PRN": "عند الحاجة",
  "Medication": "الدواء",
  "Current medications": "الأدوية الحالية",
  "Allergies": "الحساسية",
  "Primary diagnosis": "التشخيص الأساسي",
  "Secondary diagnosis": "التشخيص الثانوي",
  "Chronic Conditions": "الحالات المزمنة",
  "Clinical notes": "ملاحظات سريرية",
  "Clinical observations": "ملاحظات سريرية",
  "Clinical summary": "الملخص السريري",
  "Clinical Indication": "الإشارة السريرية",
  "Clinical justification": "التبرير السريري",
  "Nurse notes": "ملاحظات الممرض",
  "Follow-up notes": "ملاحظات المتابعة",
  "Additional notes": "ملاحظات إضافية",
  "Additional findings": "نتائج إضافية",
  "Patient responses": "ردود المريض",
  "Selected patient": "المريض المختار",
  "Patient type": "نوع المريض",
  "Override reason": "سبب التجاوز",
  "Suggested decision": "القرار المقترح",
  "Decision": "القرار",
  "Order Type": "نوع الأمر",
  "Subjective": "ذاتي",
  "Objective": "موضوعي",
  "Narrative": "السرد",
  "Captured at": "تم التسجيل في",
  "Last updated": "آخر تحديث",
  "Last maintenance (YYYY-MM-DD)": "آخر صيانة (YYYY-MM-DD)",
  "Insurance expiry (YYYY-MM-DD)": "انتهاء التأمين (YYYY-MM-DD)",
  "Scheduled at (ISO)": "موعد محدد",
  "Expected start": "البدء المتوقع",
  "Expected start date": "تاريخ البدء المتوقع",
  "Referral date": "تاريخ الإحالة",
  "Referral facility": "منشأة الإحالة",
  "Referral source": "مصدر الإحالة",
  "Referring physician": "الطبيب المُحيل",
  "Requested service": "الخدمة المطلوبة",
  "Admission date": "تاريخ القبول",
  "Consultation Type": "نوع الاستشارة",
  "Complaint category": "فئة الشكوى",
  "Protocol category": "فئة البروتوكول",
  "Available protocols": "البروتوكولات المتاحة",
  "Site / Route Notes": "ملاحظات الموقع / المسار",
  "Primary Provider": "مقدم الرعاية الرئيسي",
  "Team lead": "قائد الفريق",
  "Team lead ID": "رقم قائد الفريق",
  "Team": "الفريق",
  "Coverage areas (comma separated)": "مناطق التغطية (مفصولة بفواصل)",
  "Services (comma separated)": "الخدمات (مفصولة بفواصل)",
  "Plate number": "رقم اللوحة",
  "Test Name": "اسم الفحص",
  "Date & Time": "التاريخ والوقت",
  "Due Date": "تاريخ الاستحقاق",
  "Duration": "المدة",
  "Duration (days)": "المدة (أيام)",
  "Duration (min)": "المدة (دقائق)",
  "Avg Age (Years)": "متوسط العمر (سنة)",
  "Avg Duration": "متوسط المدة",
  "Avg Duration (min)": "متوسط المدة (دقائق)",
  "Avg Handling Time (min)": "متوسط وقت المعالجة (دقائق)",
  "Avg Onboarding Time": "متوسط وقت الاستقبال",
  "Avg Travel": "متوسط التنقل",
  "Avg Visit": "متوسط الزيارة",
  "Action": "الإجراء",
  "Entity": "الكيان",
  "Entity ID": "معرّف الكيان",
  "Record ID": "معرّف السجل",
  "Assignee": "المُكلَّف",
  "Assign to Physician (optional)": "تعيين لطبيب (اختياري)",
  "Target": "الهدف",

  // ── KPIs / Status labels ───────────────────────────────────
  "AI Acceptance": "قبول الذكاء الاصطناعي",
  "AI Deterioration": "تدهور الذكاء الاصطناعي",
  "Abnormal Now": "غير طبيعي الآن",
  "Assigned": "مُعيَّن",
  "Available": "متاح",
  "Busy": "مشغول",
  "Calls Today": "المكالمات اليوم",
  "Cancelled": "ملغى",
  "Closure %": "نسبة الإغلاق %",
  "Closure Rate": "معدّل الإغلاق",
  "Completed Today": "اكتمل اليوم",
  "Completion Rate": "معدّل الإنجاز",
  "Coordinators": "المنسقون",
  "Critical / Urgent": "حرج / عاجل",
  "Critical Alerts": "تنبيهات حرجة",
  "Delayed": "متأخر",
  "Device Issues": "مشاكل الأجهزة",
  "Discharges": "حالات الخروج",
  "En Route": "في الطريق",
  "Escalated Cases": "حالات مُصعَّدة",
  "Escalation %": "نسبة التصعيد %",
  "Facility": "المنشأة",
  "Female Patients": "المريضات",
  "Follow-Ups": "متابعات",
  "Go to next page": "الذهاب للصفحة التالية",
  "Go to previous page": "الذهاب للصفحة السابقة",
  "High NEWS2": "NEWS2 مرتفع",
  "High Risk Patients": "مرضى عاليي الخطورة",
  "Home Care Teams": "فرق الرعاية المنزلية",
  "Home Visits Today": "زيارات منزلية اليوم",
  "Hotline Calls Today": "مكالمات الخط الساخن اليوم",
  "Hotline Escalated": "تصعيد الخط الساخن",
  "Maintenance": "صيانة",
  "Mine": "خاصتي",
  "Missing Readings": "قراءات مفقودة",
  "Moderate Risk": "خطورة متوسطة",
  "Moderate": "متوسط",
  "New Activations": "تفعيلات جديدة",
  "New Admissions": "قبولات جديدة",
  "No Show Rate": "معدل عدم الحضور",
  "No Show": "لم يحضر",
  "No-Show": "لم يحضر",
  "Nurses": "الممرضون",
  "Offline": "غير متصل",
  "On-Time Performance": "الأداء في الوقت المحدد",
  "Open": "مفتوح",
  "Overdue": "متأخر",
  "Physicians": "الأطباء",
  "RPM Enrolled": "مسجَّل في المراقبة",
  "RPM Escalated": "مُصعَّد للمراقبة",
  "Readmission Rate": "معدّل إعادة القبول",
  "Ready": "جاهز",
  "Rejected Referrals": "إحالات مرفوضة",
  "SLA At-Risk": "SLA معرّض للخطر",
  "SLA Breaches": "خروقات SLA",
  "SLA Compliance": "الالتزام بـ SLA",
  "SLA at risk": "SLA معرّض للخطر",
  "Teleconsult": "استشارة عن بُعد",
  "Teleconsults Today": "استشارات اليوم",
  "RPM": "المراقبة عن بُعد",

  // ── Common UI ──────────────────────────────────────────────
  "No recent activity.": "لا يوجد نشاط حديث.",
  "No audit events.": "لا توجد أحداث تدقيق.",
  "Loading dashboard data…": "جاري تحميل بيانات اللوحة…",
  "Recent activities": "الأنشطة الأخيرة",
  "Latest audit log": "أحدث سجل تدقيق",
  "Activity feed": "تغذية الأنشطة",
  "Compliance": "الامتثال",
  "Network": "الشبكة",
  "Facility distribution": "توزيع المنشآت",
  "Operational queue": "قائمة العمليات",
  "System health": "صحة النظام",
  "What will happen next": "ما سيحدث بعد",
  "Locked user accounts": "حسابات مستخدمين مقفلة",
  "Inactive facilities": "منشآت غير نشطة",
  "Patients discharged today": "مرضى تم تخريجهم اليوم",
  "Time": "الوقت",
  "By": "بواسطة",
  "system": "النظام",
  "user": "مستخدم",

  // ── Misc ───────────────────────────────────────────────────
  "Admin": "مسؤول",
  "Onboarding": "الاستقبال",
  "Requests": "الطلبات",
  "New Request": "طلب جديد",
};

export default AR;
